module.exports = __webpack_public_path__ + "img/page30.89aaaa2d.gif";